import { Typography } from 'components/Contentful'
import { Grid } from '@achieve/ascend'
import { useAppRouter } from 'hooks/useAppRouter/useAppRouter'
import { formatPublishDate } from 'utils/conversions'
import { STORY_TYPES } from 'constants/storyTypes'
import { removePageFromQuery } from 'utils/next/routes'
import { Pill } from 'components/Pill'
import { PRESS_ROUTE } from 'constants/navigation'

import classNames from 'classnames'

function CardPress({ article, showPill }) {
  let { storyType, title, publishDate, slug, externalLink } = article || {}
  if (title?.length > 60) {
    title = title.substring(0, 60) + '...'
  }

  const { query } = useAppRouter()
  const queryString = removePageFromQuery(query)
  const ClickableWrapper = ({ children }) => {
    return (
      <a
        className="text-black no-underline hover:underline"
        target={storyType === STORY_TYPES.IN_THE_NEWS ? '_blank' : '_self'}
        rel={storyType === STORY_TYPES.IN_THE_NEWS ? 'noreferrer nofollow' : ''}
        href={
          storyType === STORY_TYPES.IN_THE_NEWS && externalLink
            ? `${externalLink}`
            : `${PRESS_ROUTE}/${slug}${queryString ? `?${queryString}` : ''}`
        }
      >
        {children}
      </a>
    )
  }

  return (
    <Grid className="flex flex-col items-center lg:items-start">
      <Grid className="flex flex-col items-center lg:items-start max-w-[286px] lg:max-w-[390px]">
        {storyType &&
          (showPill ? (
            <Pill category={storyType} article={true} pathOverride={`${PRESS_ROUTE}/`} id={0} />
          ) : (
            <Typography
              content={storyType}
              variant="bodySm"
              className="mt-3 mb-3 lg:mt-6 lg:mb-4"
              data-testid={`card-story-type`}
            />
          ))}
        <ClickableWrapper data-testid="card-title-link">
          {title && (
            <Typography
              content={title}
              component="h3"
              className={classNames('text-center lg:text-left bodyLg lg:headingMd font-bold')}
              data-testid={`card-title`}
            />
          )}
          {publishDate && (
            <Typography
              content={formatPublishDate(publishDate)}
              variant="bodySm"
              className="mt-3 mb-4 lg:mt-4 lg:mb-5"
              fontWeight="regular"
              data-testid={`card-text`}
            />
          )}
        </ClickableWrapper>
      </Grid>
    </Grid>
  )
}

export { CardPress }
